export default __webpack_public_path__ + "static/image-mob-b7eb47c37dec91b877563fb04c19422f.jpg";